export const actionLoginSetToken = (token) => ({
  type: "LOGIN_SET_TOKEN",
  token,
});

export const actionLoginSetData = (data) => ({
  type: "LOGIN_SET_DATA",
  data,
});
